import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: {}, 
  currentUserId: null,
  isLoggedIn: false, 
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const user = action.payload;
      const userId = user.id || `user-${Date.now()}`;

      state.users[userId] = {
        id: userId,
        name: user.name || "",
        mobile: user.mobile || null,
        email: user.email || null,
        token: user.token || null,
        token_type: user.token_type || "",
        address: user.address || "",
        employee_image: user.employee_image || "",
        staff_id: user.staff_id || "",
        branch_name: user.branch_name || "",
        isLoggedIn: true,
      };

      state.currentUserId = userId;
      state.isLoggedIn = true; 
    },

    logoutUser: (state) => {
      const id = state.currentUserId;
      if (id && state.users[id]) {
        state.users[id].isLoggedIn = false;
      }
      state.currentUserId = null;
      state.isLoggedIn = false; 
    },

    resetUser: (state, action) => {
      const id = action.payload?.id || state.currentUserId;
      if (id && state.users[id]) {
        delete state.users[id];
      }
      if (state.currentUserId === id) {
        state.currentUserId = null;
      }
      state.isLoggedIn = false; 
    },
  },

  updateUserId: (state, action) => {
    const { oldId, newId } = action.payload;
  
    if (state.users[oldId]) {

      state.users[newId] = {
        ...state.users[oldId],
        id: newId,
      };
  

      delete state.users[oldId];
  

      if (state.currentUserId === oldId) {
        state.currentUserId = newId;
      }
    }
  },
});

export const { setUser, logoutUser, resetUser, updateUserId } = userSlice.actions;
export default userSlice.reducer;
